import React, { forwardRef } from 'react';
import Typography from '@mui/material/Typography';

const AppStatView = forwardRef(({ value, label }, ref) => (
    <div ref={ref}>
        <Typography variant="h3" color="primary.main">
            {value}
        </Typography>
        <Typography variant="h6" color="text.secondary">
            {label}
        </Typography>
    </div>
));

export {AppStatView};